import { useEffect, useRef } from 'react';
import UseContext from 'hooks/useContext';
import { INVOICE_REMINDER_CHANGED } from './invoiceRemindersText';

/**
 * Calls `onChanged(number)` when the manual reminder modal says an invoice's
 * reminders changed (INVOICE_REMINDER_CHANGED). The tab and the detail both
 * listen to the same return, so nobody resets it: the return already there
 * when a listener mounts is an old one, and is skipped.
 */
const useInvoiceReminderChanged = (onChanged) => {
  const { modalDataReturn } = UseContext();
  const lastSeen = useRef(modalDataReturn);
  const callback = useRef(onChanged);
  callback.current = onChanged;

  useEffect(() => {
    if (lastSeen.current === modalDataReturn) return;
    lastSeen.current = modalDataReturn;
    if (modalDataReturn?.type !== INVOICE_REMINDER_CHANGED) return;
    callback.current(Number(modalDataReturn.number));
  }, [modalDataReturn]);
};

export default useInvoiceReminderChanged;
